import React from 'react';
import { Box, Typography } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';

interface EmptyStateProps {
  icon?: React.ReactNode;
  message: string;
  colSpan?: number;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  message,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1,
      py: 4,
    }}
  >
    <Box sx={{ color: 'text.disabled', fontSize: 40, lineHeight: 1 }}>
      {icon ?? <InboxOutlined fontSize="inherit" />}
    </Box>
    <Typography variant="body2" color="text.secondary">
      {message}
    </Typography>
  </Box>
);
